import "./Home_Styles/FrequentlyBookedLabTests.css";

const FrequentlyBookedLabTests = () => {
    return (
        <div className="Home_FrequentlyBookedLabTests_Container">
            <p>Frequently Booked Lab Tests</p>
            <div className="Home_FrequentlyBookedLabTests_Box">

                <div className="Home_FrequentlyBookedLabTests_Box_Item">
                    <div>
                        <button>64% OFF</button>
                    </div>
                    <div>Healthy 2022 Full Body Checkup</div>
                    <div>Diagnostic tool for screening and monitoring of your health</div>
                    <div className="Home_FrequentlyBookedLabTests_Bottom_Box">
                        <div>
                            <p>₹2990</p>
                            <p>₹1049</p>
                        </div>
                        <div>
                            <img src="https://s3.ap-south-1.amazonaws.com/pe-neon-public/diagnostics/production/recommendationWidget/7e6ed82a2c373d1db2ea81a09e2fbb4c.png?dim=256x0" alt="" />
                        </div>
                    </div>
                </div>

                <div className="Home_FrequentlyBookedLabTests_Box_Item">
                    <div>
                        <button>59% OFF</button>
                    </div>
                    <div>Women's Master Checkup with Cancer & Arthritis Screening</div>
                    <div>Measures Vitamins, Arthritis & Cancer screening and other essential parameters</div>
                    <div className="Home_FrequentlyBookedLabTests_Bottom_Box">
                        <div>
                            <p>₹4990</p>
                            <p>₹1999</p>
                        </div>
                        <div>
                            <img src="https://s3.ap-south-1.amazonaws.com/pe-neon-public/diagnostics/production/recommendationWidget/4ff607383fad35e4af5639c3e7709734.png?dim=256x0" alt="" />
                        </div>
                    </div>
                </div>

                <div className="Home_FrequentlyBookedLabTests_Box_Item">
                    <div>
                        <button>60% OFF</button>
                    </div>
                    <div>Post Prandial Blood Sugar (PPBS)</div>
                    <div>Measures your blood sugar levels after last meal</div>
                    <div className="Home_FrequentlyBookedLabTests_Bottom_Box">
                        <div>
                            <p>₹500</p>
                            <p>₹199</p>
                        </div>
                        <div>
                            <img src="https://s3.ap-south-1.amazonaws.com/pe-neon-public/diagnostics/production/recommendationWidget/f39e65011d9439e28c6500a1e444735e.png?dim=256x0" alt="" />
                        </div>
                    </div>
                </div>

                <div className="Home_FrequentlyBookedLabTests_Box_Item">
                    <div>
                        <button>42% OFF</button>
                    </div>
                    <div>Total IgE</div>
                    <div>Test to screen for and detect allergies</div>
                    <div className="Home_FrequentlyBookedLabTests_Bottom_Box">
                        <div>
                            <p>₹650</p>
                            <p>₹375</p>
                        </div>
                        <div>
                            <img src="https://s3.ap-south-1.amazonaws.com/pe-neon-public/diagnostics/production/recommendationWidget/4ff607383fad35e4af5639c3e7709734.png?dim=256x0" alt="" />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export {FrequentlyBookedLabTests};
        
   